import { DateTimeField } from "@/src/components"
import { Box, Stack, Typography } from "@mui/material"
import { DataTable, List, ReferenceField, ArrayField, SingleFieldList, ChipField, BooleanField, DateField, TextField, useFieldValue, FieldProps, ReferenceArrayField } from "react-admin"
import JsonFormatter from "react-json-formatter"

export const BulkMessageList = () => {

    return (
        <List>
            <DataTable expand={<ExpandField />}>
                {/* <DataTable.Col source="id" /> */}
                <DataTable.Col source="sender">

                    <ReferenceField source="sender" reference="user">
                        <TextField source="profile.nickname" variant="caption" />
                    </ReferenceField>
                </DataTable.Col>

                <DataTable.Col source="message.template" />



                <DataTable.Col source="recipients">
                    <ArrayField source="recipients">
                        <SingleFieldList linkType={false}>
                            <ReferenceField source="user" reference="user">
                                <TextField source="profile.nickname" variant="caption" />
                            </ReferenceField>
                        </SingleFieldList>
                    </ArrayField>
                </DataTable.Col>

                <DataTable.NumberCol source="maxRecipients" />
                {/* <DataTable.Col source="query">
                    <JsonField source="query" />
                </DataTable.Col> */}
                <DataTable.Col source="isCompleted">
                    <BooleanField source="isCompleted" />
                </DataTable.Col>
                <DataTable.Col source="createdAt">
                    <DateTimeField source="createdAt" />
                </DataTable.Col>
                <DataTable.Col source="updatedAt">
                    <DateTimeField source="updatedAt" />
                </DataTable.Col>

            </DataTable>
        </List>
    )
}


const ExpandField = () => {
    return (
        <JsonField source="query" />
    )
}

const JsonField = (props: FieldProps) => {

    const recordValue = useFieldValue(props)
    if (recordValue) {
        const text = JSON.stringify(recordValue);
        const jsonStyle = {
            propertyStyle: { color: 'red' },
            stringStyle: { color: 'green' },
            numberStyle: { color: 'darkorange' }
        };

        return (
            <Box sx={{ padding: "10px" }}>
            <Typography component="div" variant="caption">
                <JsonFormatter json={text} tabWith={4} jsonStyle={jsonStyle} />
            </Typography>
            </Box>
        )
    } else {
        return null
    };


}